module.exports = __webpack_public_path__ + "img/will-health.502991f9.svg";